export default __webpack_public_path__ + "static/media/critical-illness-icon.97a94f92.svg";